module.exports = __webpack_public_path__ + "img/mu.d6c5b726.svg";